import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import graphiqlPlugin from '@backstage-community/plugin-graphiql/alpha';
import n8nPlugin from '@backstage-community/plugin-n8n/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { themeModule } from './theme/themeModule';
import { signInModule } from './theme/signInModule';
import { assessmentsPlugin } from './plugins/assessments';
import { platformPlugin } from './plugins/platform';

// The new frontend system only mounts what is listed here. techdocs, api-docs
// and kubernetes were already dependencies but were never registered, so their
// routes 404'd and their entity tabs never appeared — the packages were present
// and inert. Everything below ships an /alpha entry point, which is what the
// new system consumes; old-system-only plugins need convertLegacyPlugin from
// @backstage/core-compat-api instead.
export default createApp({
  features: [
    catalogPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    techdocsPlugin,
    apiDocsPlugin,
    kubernetesPlugin,
    searchPlugin,
    userSettingsPlugin,
    graphiqlPlugin,
    n8nPlugin,
    navModule,
    homeModule,
    themeModule,
    signInModule,
    assessmentsPlugin,
    platformPlugin,
  ],
});
